<template>
  <modal
    title="Crée une ronde"
    @close="cancel()">

    <div class="ronde-create">
      <div v-if="createModal.message !== null"
           v-bind:class="'callout callout-'+createModal.message.type">
        <p>{{createModal.message.text}}</p>
      </div>
      <div class="form-horizontal">
        <div class="form-group">
          <label class="control-label col-sm-4">Nom</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="ronde.nom"/>
          </div>
        </div>
      </div>
      <div class="buttons" v-if="!createModal.canOnlyExitModal">
        <div class="btn btn-default" v-on:click="cancel()">Annuler</div>
        <div class="btn btn-primary" v-on:click="doCreate()">Valider</div>
      </div>
      <div class="loading-overlay" v-if="createModal.loading">
        Chargement ...
      </div>

    </div>
  </modal>
</template>

<script>
  import Modal from '../../modals/ModalBasic'

  export default {
    components: {
      Modal,
    },
    data: function () {
      return {
        ronde: {
          nom: '',
          numero: '',
          agentReferent_id: null,
          agentPlanifie_id: null
        },
      }
    },
    computed: {
      createModal: function () {
        return this.$store.state.rondes.createModal
      },
    },
    methods: {
      cancel: function () {
        this.$store.dispatch('closeRondeCreateModal')
      },
      doCreate: function () {
        this.$store.dispatch('createRondeV2', this.ronde)
      },
    },
    props: [
      'hideDispatchAction',
    ],
  }
</script>



// WEBPACK FOOTER //
// RondeCreateModal.vue?687c185a